import React from 'react';
import type { TutorialData } from '../types';

interface TutorialCardProps {
  data: TutorialData;
  openModal: (key: string) => void;
  currentLang: string;
  t: (key: string, lang: string) => string;
}

const TutorialCard: React.FC<TutorialCardProps> = ({
  data,
  openModal,
  currentLang,
  t
}) => {
  const titleKey = `tutorials.${data.key}.title`;
  const descriptionKey = `tutorials.${data.key}.description`;


  return (
    <div className="tutorial-card">
      <div 
        className="mobi-placeholder" 
        style={{ backgroundColor: data.bgColor }}
      >
        {data.url && (
          <div className="tutorial-thumbnail-container">
            <img 
              src={data.url} 
              alt={t(titleKey, currentLang)}
              className="tutorial-thumbnail"
            />
          </div>
        )}
        <span className="mobi-tag">{data.mobiTag}</span>
      </div>
      <h4 className="card-title">
        {t(titleKey, currentLang)}
      </h4>
      <p className="card-description">
        {t(descriptionKey, currentLang)}
      </p>
      <button 
        onClick={(e) => {
          e.stopPropagation();
          if (data.key === 'newbie') {
            openModal('stack');
          } else {
            openModal(data.key);
          }
        }}
        className="pixel-button card-button"
      >
        {data.key === 'newbie' ? 'Ver Tutorial de Stack' : t('button.view', currentLang)}
      </button>
    </div>
  );
};

export default TutorialCard;
